import Paper from "@material-ui/core/esm/Paper";
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusBullet from 'components/StatusBullet/StatusBullet';
import { Title, Info } from 'components/Text';
import useVehicleIconStyles from 'components/VehicleIcon/VehicleIconStyles';
import getObeStatusBullet from 'utils/obes/getObeStatusBullet';
import useStyles from './VehicleCardStyles';
export default function VehicleCardNoObe({
  vehicleRegistrationNumber
}) {
  const {
    t
  } = useTranslation();
  const {
    vehicleRoot,
    information,
    spacingLeft
  } = useStyles();
  const {
    icon
  } = useVehicleIconStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    className: vehicleRoot,
    elevation: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: information
  }, /*#__PURE__*/React.createElement(DepartureBoardIcon, {
    className: icon
  }), /*#__PURE__*/React.createElement("div", {
    className: spacingLeft
  }, /*#__PURE__*/React.createElement(Title, {
    isBold: true,
    hasNoSpacing: true
  }, vehicleRegistrationNumber || t('vehicles.no_attached_vehicle')), /*#__PURE__*/React.createElement(Info, {
    align: "left"
  }, /*#__PURE__*/React.createElement(StatusBullet, {
    status: getObeStatusBullet.AwaitingApproval,
    text: t('status.awaiting_delivery')
  })))));
}